import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { DownloadExcelUserListResponseType } from '../types/accountUser';
import { ACCOUNT_USER_LIST_QUERY_KEYS } from './queryKeys';
import { AccountUserApiV2 } from '../../../../../../lib/api/account/user/AccountUserApiV2';
import { UserListFilterOptionType } from '../types/options';
import noticeExcelDownloadResult from '../../../../../../lib/noticeExcelDownloadResult';

export const useRequestDownloadExcelUserListQuery = (
  filterOption: UserListFilterOptionType,
): UseQueryResult<DownloadExcelUserListResponseType, Error> => {
  return useQuery({
    queryKey: [...ACCOUNT_USER_LIST_QUERY_KEYS.REQUEST_DOWNLOAD_EXCEL, filterOption],
    queryFn: () => AccountUserApiV2.requestDownloadExcelUserList(filterOption),
    enabled: false,
    meta: {
      onSuccess: (data: DownloadExcelUserListResponseType) => {
        noticeExcelDownloadResult(data.adminEmail);
      },
    },
  });
};
